<!-- VIEW: MONITOR -->
<div class="flex-1 bg-slate-50/50 p-1 overflow-hidden flex flex-col h-full">
    <!-- Global Overlay for Filter Popup -->
    <div *ngIf="activeFilterColumn()" class="fixed inset-0 z-30" (click)="closeFilterPopup()"></div>

    <div class="w-full h-full flex flex-col px-1">
        <!-- Compact Header -->
        <header class="mb-2 flex justify-between items-center shrink-0 pt-2">
            <div class="flex items-center gap-4">
                <div>
                    <h1 class="text-lg font-bold text-slate-800 leading-tight">Monitor de Execução</h1>
                    <p class="text-[10px] text-slate-500">Histórico de cálculos do MRP</p>
                </div>
            </div>
            <div class="flex gap-2 items-center">
                <span *ngIf="updatedAt()" class="text-[10px] font-medium text-slate-400 hidden sm:block">
                    Atualizado em: {{ updatedAt() | date:'HH:mm' }}
                </span>
                <button (click)="refreshData()"
                    class="btn-icon p-1.5 rounded-full text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 transition-all"
                    title="Atualizar dados">
                    <lucide-icon [img]="icons.RefreshCw" class="w-4 h-4"
                        [class.animate-spin]="mrpService.isLoading()"></lucide-icon>
                </button>

                <button *ngIf="hasActiveFilters()" (click)="clearAllFilters()"
                    class="flex items-center gap-1 px-2 py-1 text-[10px] font-bold text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors"
                    title="Remover todos os filtros">
                    <lucide-icon [img]="icons.FilterX" class="w-3.5 h-3.5"></lucide-icon>
                    Limpar Filtros
                </button>


                <button *ngIf="authService.hasRole(['Admin', 'Operator'])" (click)="openNewExecutionModal()"
                    class="btn-primary flex items-center gap-1 px-3 py-1.5 bg-indigo-600 text-white text-xs font-bold rounded-lg shadow-md hover:bg-indigo-700 transition-colors">
                    <lucide-icon [img]="icons.Plus" class="w-3.5 h-3.5"></lucide-icon> Nova Execução
                </button>
            </div>
        </header>

        <!-- Compact KPIs -->
        <div class="grid grid-cols-2 lg:grid-cols-5 gap-2 mb-2 shrink-0">
            <!-- KPI 1 -->
            <div
                class="bg-white p-3 rounded-xl shadow-sm border border-slate-200 flex items-center justify-between relative overflow-hidden group">
                <div class="z-10 flex-1 min-w-0 pr-2">
                    <p class="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-0.5 truncate">
                        Processadas</p>
                    <p class="text-xl lg:text-2xl font-black text-slate-800 tracking-tight truncate">{{ kpis().processed
                        }}</p>
                </div>
                <div
                    class="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center text-emerald-600 shadow-inner z-10 shrink-0">
                    <lucide-icon [img]="icons.Check" class="w-5 h-5"></lucide-icon>
                </div>
            </div>

            <!-- KPI 2 -->
            <div
                class="bg-white p-3 rounded-xl shadow-sm border border-slate-200 flex items-center justify-between relative overflow-hidden group">
                <div class="z-10 flex-1 min-w-0 pr-2">
                    <p class="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-0.5 truncate">
                        Processando</p>
                    <p class="text-xl lg:text-2xl font-black text-slate-800 tracking-tight truncate">{{
                        kpis().processing }}</p>
                </div>
                <div
                    class="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600 shadow-inner z-10 shrink-0">
                    <lucide-icon [img]="icons.RefreshCw" class="w-5 h-5"></lucide-icon>
                </div>
            </div>

            <!-- KPI 3 -->
            <div
                class="bg-white p-3 rounded-xl shadow-sm border border-slate-200 flex items-center justify-between relative overflow-hidden group">
                <div class="z-10 flex-1 min-w-0 pr-2">
                    <p class="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-0.5 truncate">Erros</p>
                    <p class="text-xl lg:text-2xl font-black text-slate-800 tracking-tight truncate">{{ kpis().errors }}
                    </p>
                </div>
                <div
                    class="w-10 h-10 rounded-lg bg-rose-100 flex items-center justify-center text-rose-600 shadow-inner z-10 shrink-0">
                    <lucide-icon [img]="icons.AlertTriangle" class="w-5 h-5"></lucide-icon>
                </div>
            </div>

            <!-- KPI 4 -->
            <div
                class="bg-white p-3 rounded-xl shadow-sm border border-slate-200 flex items-center justify-between relative overflow-hidden group">
                <div class="z-10 flex-1 min-w-0 pr-2">
                    <p class="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-0.5 truncate">Fila</p>
                    <p class="text-xl lg:text-2xl font-black text-slate-800 tracking-tight truncate">{{ kpis().queue }}
                    </p>
                </div>
                <div
                    class="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center text-amber-600 shadow-inner z-10 shrink-0">
                    <lucide-icon [img]="icons.Clock" class="w-5 h-5"></lucide-icon>
                </div>
            </div>

            <!-- KPI 5 -->
            <div
                class="bg-white p-3 rounded-xl shadow-sm border border-slate-200 flex items-center justify-between relative overflow-hidden group">
                <div class="z-10 flex-1 min-w-0 pr-2">
                    <p class="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-0.5 truncate">Tempo
                        Médio</p>
                    <p class="text-xl lg:text-2xl font-black text-slate-800 tracking-tight truncate">{{
                        kpis().avgTimeStr }}</p>
                </div>
                <div
                    class="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center text-indigo-600 shadow-inner z-10 shrink-0">
                    <lucide-icon [img]="icons.Clock" class="w-5 h-5"></lucide-icon>
                </div>
            </div>
        </div>

        <!-- Tabela Estilo Excel Filling Height -->
        <div
            class="bg-white rounded-xl shadow-sm border border-slate-200 relative flex-1 min-h-0 flex flex-col overflow-hidden">
            <!-- Loading Overlay -->
            <div *ngIf="mrpService.isLoading()"
                class="absolute inset-0 bg-white/80 backdrop-blur-sm z-50 flex flex-col items-center justify-center transition-all duration-300">
                <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mb-4"></div>
                <span class="text-sm font-medium text-slate-600 animate-pulse">Carregando dados...</span>
            </div>

            <div class="overflow-auto flex-1">
                <table
                    class="w-full text-left border-collapse whitespace-nowrap table-fixed min-w-[1200px] transition-opacity duration-300"
                    [class.opacity-50]="mrpService.isLoading()">
                    <thead class="sticky top-0 shadow-sm" [style.z-index]="activeFilterColumn() ? 40 : 20">
                        <tr class="bg-slate-50 border-b border-slate-200">

                            <!-- Coluna: TICKET (ID) -->
                            <th class="p-2 align-middle relative border-r border-slate-100 last:border-0 w-[6%] text-xs font-bold text-slate-600 sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'id' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <div class="flex items-center gap-1 cursor-pointer group flex-1 truncate"
                                        (click)="toggleSort('id')">
                                        <span class="truncate">TICKET</span>
                                        <span *ngIf="sortConfig().column === 'id'" class="text-indigo-500 shrink-0">
                                            <lucide-icon
                                                [img]="sortConfig().direction === 'asc' ? icons.ArrowUp : icons.ArrowDown"
                                                class="w-3 h-3"></lucide-icon>
                                        </span>
                                    </div>
                                    <button (click)="toggleFilterPopup('id', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="columnFilters()['id']">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                <div *ngIf="activeFilterColumn() === 'id'"
                                    class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-3">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Ticket</span>
                                    </div>
                                    <input type="text" [value]="columnFilters()['id'] || ''"
                                        (input)="updateFilter('id', $event)"
                                        class="w-full text-xs px-3 py-2 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-3 placeholder:text-slate-400"
                                        placeholder="Contém...">
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('id')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                            </th>

                            <!-- Coluna: Início Execução -->
                            <th class="p-3 align-middle relative border-r border-slate-100 last:border-0 w-[11%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'startDate' ? 50 : 20">
                                <div class="flex items-center justify-between gap-2">
                                    <div class="flex items-center gap-1 cursor-pointer group flex-1 truncate"
                                        (click)="toggleSort('startDate')">
                                        <span
                                            class="text-[11px] font-bold uppercase tracking-wider text-slate-600 group-hover:text-indigo-600 transition-colors truncate">DATA
                                            INCLUSÃO</span>
                                        <span *ngIf="sortConfig().column === 'startDate'"
                                            class="text-indigo-500 shrink-0">
                                            <lucide-icon
                                                [img]="sortConfig().direction === 'asc' ? icons.ArrowUp : icons.ArrowDown"
                                                class="w-3.5 h-3.5"></lucide-icon>
                                        </span>
                                    </div>
                                    <button (click)="toggleFilterPopup('startDate', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-1 rounded hover:bg-slate-200 transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterDateStart() || filterDateEnd()">
                                        <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5"></lucide-icon>
                                    </button>
                                </div>
                                <div *ngIf="activeFilterColumn() === 'startDate'"
                                    class="absolute left-0 top-full mt-2 w-60 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default overflow-hidden"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar por Período</span>
                                    </div>
                                    <div class="flex items-center gap-2 mb-2">
                                        <label
                                            class="text-[10px] font-semibold text-slate-500 uppercase w-6 shrink-0">De</label>
                                        <input type="date" [value]="filterDateStart()"
                                            (input)="filterDateStart.set($any($event.target).value)"
                                            class="flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none">
                                    </div>
                                    <div class="flex items-center gap-2 mb-3">
                                        <label
                                            class="text-[10px] font-semibold text-slate-500 uppercase w-6 shrink-0">Até</label>
                                        <input type="date" [value]="filterDateEnd()"
                                            (input)="filterDateEnd.set($any($event.target).value)"
                                            class="flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none">
                                    </div>
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('startDate')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                            </th>

                            <!-- Coluna: Tempo -->
                            <th class="p-3 align-middle relative border-r border-slate-100 last:border-0 w-[7%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'executionTime' ? 50 : 20">
                                <div class="flex items-center justify-between gap-2">
                                    <div class="flex items-center gap-1 cursor-pointer group flex-1 truncate"
                                        (click)="toggleSort('executionTime')">
                                        <span
                                            class="text-[11px] font-bold uppercase tracking-wider text-slate-600 group-hover:text-indigo-600 transition-colors truncate">Tempo</span>
                                        <span *ngIf="sortConfig().column === 'executionTime'"
                                            class="text-indigo-500 shrink-0">
                                            <lucide-icon
                                                [img]="sortConfig().direction === 'asc' ? icons.ArrowUp : icons.ArrowDown"
                                                class="w-3.5 h-3.5"></lucide-icon>
                                        </span>
                                    </div>
                                    <button (click)="toggleFilterPopup('executionTime', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-1 rounded hover:bg-slate-200 transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="columnFilters()['executionTime']">
                                        <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5"></lucide-icon>
                                    </button>
                                </div>
                                <div *ngIf="activeFilterColumn() === 'executionTime'"
                                    class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-3">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Tempo</span>
                                    </div>
                                    <input type="text" [value]="columnFilters()['executionTime'] || ''"
                                        (input)="updateFilter('executionTime', $event)"
                                        class="w-full text-xs px-3 py-2 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-3 placeholder:text-slate-400"
                                        placeholder="Ex: 00:05...">
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('executionTime')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                            </th>

                            <!-- Coluna: Início Process. -->
                            <th class="p-2 align-middle relative border-r border-slate-100 last:border-0 w-[10%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'startedAt' ? 50 : 20">
                                <div class="flex items-center justify-between gap-2">
                                    <div class="flex items-center gap-1 cursor-pointer group flex-1 truncate"
                                        (click)="toggleSort('startedAt')">
                                        <span
                                            class="text-[10px] font-bold uppercase tracking-wider text-slate-600 group-hover:text-indigo-600 transition-colors truncate">Início
                                            Process.</span>
                                        <span *ngIf="sortConfig().column === 'startedAt'"
                                            class="text-indigo-500 shrink-0">
                                            <lucide-icon
                                                [img]="sortConfig().direction === 'asc' ? icons.ArrowUp : icons.ArrowDown"
                                                class="w-3 h-3"></lucide-icon>
                                        </span>
                                    </div>
                                    <button (click)="toggleFilterPopup('startedAt', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded hover:bg-slate-200 transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterStartedAtStart() || filterStartedAtEnd()">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                <div *ngIf="activeFilterColumn() === 'startedAt'"
                                    class="absolute left-0 top-full mt-2 w-60 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default overflow-hidden"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar por Período</span>
                                    </div>
                                    <div class="flex items-center gap-2 mb-2">
                                        <label
                                            class="text-[10px] font-semibold text-slate-500 uppercase w-6 shrink-0">De</label>
                                        <input type="date" [value]="filterStartedAtStart()"
                                            (input)="filterStartedAtStart.set($any($event.target).value)"
                                            class="flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none">
                                    </div>
                                    <div class="flex items-center gap-2 mb-3">
                                        <label
                                            class="text-[10px] font-semibold text-slate-500 uppercase w-6 shrink-0">Até</label>
                                        <input type="date" [value]="filterStartedAtEnd()"
                                            (input)="filterStartedAtEnd.set($any($event.target).value)"
                                            class="flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none">
                                    </div>
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('startedAt')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                            </th>

                            <!-- Coluna: Fim Process. -->
                            <th class="p-2 align-middle relative border-r border-slate-100 last:border-0 w-[10%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'finishedAt' ? 50 : 20">
                                <div class="flex items-center justify-between gap-2">
                                    <div class="flex items-center gap-1 cursor-pointer group flex-1 truncate"
                                        (click)="toggleSort('finishedAt')">
                                        <span
                                            class="text-[10px] font-bold uppercase tracking-wider text-slate-600 group-hover:text-indigo-600 transition-colors truncate">Fim
                                            Process.</span>
                                        <span *ngIf="sortConfig().column === 'finishedAt'"
                                            class="text-indigo-500 shrink-0">
                                            <lucide-icon
                                                [img]="sortConfig().direction === 'asc' ? icons.ArrowUp : icons.ArrowDown"
                                                class="w-3 h-3"></lucide-icon>
                                        </span>
                                    </div>
                                    <button (click)="toggleFilterPopup('finishedAt', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded hover:bg-slate-200 transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterFinishedAtStart() || filterFinishedAtEnd()">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                <div *ngIf="activeFilterColumn() === 'finishedAt'"
                                    class="absolute left-0 top-full mt-2 w-60 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default overflow-hidden"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar por Período</span>
                                    </div>
                                    <div class="flex items-center gap-2 mb-2">
                                        <label
                                            class="text-[10px] font-semibold text-slate-500 uppercase w-6 shrink-0">De</label>
                                        <input type="date" [value]="filterFinishedAtStart()"
                                            (input)="filterFinishedAtStart.set($any($event.target).value)"
                                            class="flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none">
                                    </div>
                                    <div class="flex items-center gap-2 mb-3">
                                        <label
                                            class="text-[10px] font-semibold text-slate-500 uppercase w-6 shrink-0">Até</label>
                                        <input type="date" [value]="filterFinishedAtEnd()"
                                            (input)="filterFinishedAtEnd.set($any($event.target).value)"
                                            class="flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none">
                                    </div>
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('finishedAt')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                            </th>

                            <!-- Coluna: Perfil -->
                            <!-- Coluna: Perfil -->
                            <th class="p-3 align-middle relative border-r border-slate-100 last:border-0 w-[12%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'profileName' ? 50 : 20">
                                <div class="flex items-center justify-between gap-2">
                                    <div class="flex items-center gap-1 cursor-pointer group flex-1 truncate"
                                        (click)="toggleSort('profileName')">
                                        <span
                                            class="text-[11px] font-bold uppercase tracking-wider text-slate-600 group-hover:text-indigo-600 transition-colors truncate">Perfil</span>
                                        <span *ngIf="sortConfig().column === 'profileName'"
                                            class="text-indigo-500 shrink-0">
                                            <lucide-icon
                                                [img]="sortConfig().direction === 'asc' ? icons.ArrowUp : icons.ArrowDown"
                                                class="w-3.5 h-3.5"></lucide-icon>
                                        </span>
                                    </div>
                                    <button (click)="toggleFilterPopup('profileName', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-1 rounded hover:bg-slate-200 transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterProfileIds().size > 0">
                                        <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5"></lucide-icon>
                                    </button>
                                </div>
                                <div *ngIf="activeFilterColumn() === 'profileName'"
                                    class="absolute left-0 top-full mt-2 w-72 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Perfil</span>
                                    </div>
                                    <input type="text" [value]="filterProfileSearch()"
                                        (input)="filterProfileSearch.set($any($event.target).value)"
                                        class="w-full text-xs px-3 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-2 placeholder:text-slate-400"
                                        placeholder="Buscar perfil...">
                                    <div class="flex gap-2 mb-2">
                                        <button (click)="selectAllProfiles()"
                                            class="text-[10px] font-semibold text-indigo-600 hover:text-indigo-800">Selecionar
                                            todos</button>
                                        <span class="text-slate-300">|</span>
                                        <button (click)="clearProfileSelection()"
                                            class="text-[10px] font-semibold text-slate-500 hover:text-slate-700">Limpar</button>
                                    </div>
                                    <div class="max-h-40 overflow-y-auto border border-slate-100 rounded-lg">
                                        @for (profile of filterableProfiles(); track profile.id) {
                                        <label
                                            class="flex items-center gap-2 px-2 py-1.5 hover:bg-slate-50 cursor-pointer text-[11px] text-slate-700 border-b border-slate-50 last:border-0">
                                            <input type="checkbox" [checked]="filterProfileIds().has(profile.id)"
                                                (change)="toggleProfileFilter(profile.id)"
                                                class="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500">
                                            <span class="truncate">{{ profile.name }}</span>
                                        </label>
                                        }
                                    </div>
                                    <div class="flex justify-between items-center border-t border-slate-100 pt-2 mt-2">
                                        <span class="text-[10px] text-slate-400">{{ filterProfileIds().size }}
                                            selecionado(s)</span>
                                        <div class="flex gap-2">
                                            <button (click)="clearFilter('profileName')"
                                                class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                            <button (click)="closeFilterPopup()"
                                                class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                        </div>
                                    </div>
                                </div>
                            </th>

                            <!-- Coluna: Filial -->
                            <!-- Coluna: Filial -->
                            <th class="p-3 align-middle relative border-r border-slate-100 last:border-0 w-[8%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'branchCode' ? 50 : 20">
                                <div class="flex items-center justify-between gap-2">
                                    <div class="flex items-center gap-1 cursor-pointer group flex-1 truncate"
                                        (click)="toggleSort('branchCode')">
                                        <span
                                            class="text-[11px] font-bold uppercase tracking-wider text-slate-600 group-hover:text-indigo-600 transition-colors truncate">Filial</span>
                                        <span *ngIf="sortConfig().column === 'branchCode'"
                                            class="text-indigo-500 shrink-0">
                                            <lucide-icon
                                                [img]="sortConfig().direction === 'asc' ? icons.ArrowUp : icons.ArrowDown"
                                                class="w-3.5 h-3.5"></lucide-icon>
                                        </span>
                                    </div>
                                    <button (click)="toggleFilterPopup('branchCode', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-1 rounded hover:bg-slate-200 transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterBranchIds().size > 0">
                                        <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5"></lucide-icon>
                                    </button>
                                </div>
                                <div *ngIf="activeFilterColumn() === 'branchCode'"
                                    class="absolute left-0 top-full mt-2 w-80 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Filial</span>
                                    </div>
                                    <input type="text" [value]="filterBranchSearch()"
                                        (input)="filterBranchSearch.set($any($event.target).value)"
                                        class="w-full text-xs px-3 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-2 placeholder:text-slate-400"
                                        placeholder="Buscar filial...">
                                    <div class="flex gap-2 mb-2">
                                        <button (click)="selectAllBranches()"
                                            class="text-[10px] font-semibold text-indigo-600 hover:text-indigo-800">Selecionar
                                            todos</button>
                                        <span class="text-slate-300">|</span>
                                        <button (click)="clearBranchSelection()"
                                            class="text-[10px] font-semibold text-slate-500 hover:text-slate-700">Limpar</button>
                                    </div>
                                    <div class="max-h-40 overflow-y-auto border border-slate-100 rounded-lg">
                                        @for (branch of filterableBranches(); track branch.id) {
                                        <label
                                            class="flex items-center gap-2 px-2 py-1.5 hover:bg-slate-50 cursor-pointer text-[11px] text-slate-700 border-b border-slate-50 last:border-0">
                                            <input type="checkbox" [checked]="filterBranchIds().has(branch.id)"
                                                (change)="toggleBranchFilter(branch.id)"
                                                class="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500">
                                            <span class="truncate"><b class="text-slate-800">{{ branch.code }}</b> — {{
                                                branch.name }}</span>
                                        </label>
                                        }
                                    </div>
                                    <div class="flex justify-between items-center border-t border-slate-100 pt-2 mt-2">
                                        <span class="text-[10px] text-slate-400">{{ filterBranchIds().size }}
                                            selecionado(s)</span>
                                        <div class="flex gap-2">
                                            <button (click)="clearFilter('branchCode')"
                                                class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                            <button (click)="closeFilterPopup()"
                                                class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                        </div>
                                    </div>
                                </div>
                            </th>

                            <!-- Coluna: Nome Filial -->
                            <!-- Coluna: Nome Filial -->
                            <th class="p-3 align-middle relative border-r border-slate-100 last:border-0 w-[14%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'branchName' ? 50 : 20">
                                <div class="flex items-center justify-between gap-2">
                                    <div class="flex items-center gap-1 cursor-pointer group flex-1 truncate"
                                        (click)="toggleSort('branchName')">
                                        <span
                                            class="text-[11px] font-bold uppercase tracking-wider text-slate-600 group-hover:text-indigo-600 transition-colors truncate">Nome</span>
                                        <span *ngIf="sortConfig().column === 'branchName'"
                                            class="text-indigo-500 shrink-0">
                                            <lucide-icon
                                                [img]="sortConfig().direction === 'asc' ? icons.ArrowUp : icons.ArrowDown"
                                                class="w-3.5 h-3.5"></lucide-icon>
                                        </span>
                                    </div>
                                    <button (click)="toggleFilterPopup('branchName', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-1 rounded hover:bg-slate-200 transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterBranchIds().size > 0">
                                        <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5"></lucide-icon>
                                    </button>
                                </div>
                                <div *ngIf="activeFilterColumn() === 'branchName'"
                                    class="absolute right-0 top-full mt-2 w-80 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Filial</span>
                                    </div>
                                    <input type="text" [value]="filterBranchSearch()"
                                        (input)="filterBranchSearch.set($any($event.target).value)"
                                        class="w-full text-xs px-3 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-2 placeholder:text-slate-400"
                                        placeholder="Buscar filial...">
                                    <div class="flex gap-2 mb-2">
                                        <button (click)="selectAllBranches()"
                                            class="text-[10px] font-semibold text-indigo-600 hover:text-indigo-800">Selecionar
                                            todos</button>
                                        <span class="text-slate-300">|</span>
                                        <button (click)="clearBranchSelection()"
                                            class="text-[10px] font-semibold text-slate-500 hover:text-slate-700">Limpar</button>
                                    </div>
                                    <div class="max-h-40 overflow-y-auto border border-slate-100 rounded-lg">
                                        @for (branch of filterableBranches(); track branch.id) {
                                        <label
                                            class="flex items-center gap-2 px-2 py-1.5 hover:bg-slate-50 cursor-pointer text-[11px] text-slate-700 border-b border-slate-50 last:border-0">
                                            <input type="checkbox" [checked]="filterBranchIds().has(branch.id)"
                                                (change)="toggleBranchFilter(branch.id)"
                                                class="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500">
                                            <span class="truncate"><b class="text-slate-800">{{ branch.code }}</b> — {{
                                                branch.name }}</span>
                                        </label>
                                        }
                                    </div>
                                    <div class="flex justify-between items-center border-t border-slate-100 pt-2 mt-2">
                                        <span class="text-[10px] text-slate-400">{{ filterBranchIds().size }}
                                            selecionado(s)</span>
                                        <div class="flex gap-2">
                                            <button (click)="clearFilter('branchName')"
                                                class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                            <button (click)="closeFilterPopup()"
                                                class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                        </div>
                                    </div>
                                </div>
                            </th>

                            <!-- Coluna: Status -->
                            <!-- Coluna: Status -->
                            <th class="p-3 align-middle relative last:border-0 w-[15%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'status' ? 50 : 20">
                                <div class="flex items-center justify-between gap-2">
                                    <div class="flex items-center gap-1 cursor-pointer group flex-1 truncate"
                                        (click)="toggleSort('status')">
                                        <span
                                            class="text-[11px] font-bold uppercase tracking-wider text-slate-600 group-hover:text-indigo-600 transition-colors truncate">Status</span>
                                        <span *ngIf="sortConfig().column === 'status'" class="text-indigo-500 shrink-0">
                                            <lucide-icon
                                                [img]="sortConfig().direction === 'asc' ? icons.ArrowUp : icons.ArrowDown"
                                                class="w-3.5 h-3.5"></lucide-icon>
                                        </span>
                                    </div>
                                    <button (click)="toggleFilterPopup('status', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-1 rounded hover:bg-slate-200 transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterStatusValues().size > 0">
                                        <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5"></lucide-icon>
                                    </button>
                                </div>
                                <div *ngIf="activeFilterColumn() === 'status'"
                                    class="absolute right-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Status</span>
                                    </div>
                                    <div class="flex gap-2 mb-2">
                                        <button (click)="selectAllStatuses()"
                                            class="text-[10px] font-semibold text-indigo-600 hover:text-indigo-800">Selecionar
                                            todos</button>
                                        <span class="text-slate-300">|</span>
                                        <button (click)="clearStatusSelection()"
                                            class="text-[10px] font-semibold text-slate-500 hover:text-slate-700">Limpar</button>
                                    </div>
                                    <div class="border border-slate-100 rounded-lg">
                                        @for (opt of statusOptions; track opt.value) {
                                        <label
                                            class="flex items-center gap-2 px-2 py-1.5 hover:bg-slate-50 cursor-pointer text-[11px] text-slate-700 border-b border-slate-50 last:border-0">
                                            <input type="checkbox" [checked]="filterStatusValues().has(opt.value)"
                                                (change)="toggleStatusFilter(opt.value)"
                                                class="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500">
                                            <span>{{ opt.label }}</span>
                                        </label>
                                        }
                                    </div>
                                    <div class="flex justify-between items-center border-t border-slate-100 pt-2 mt-2">
                                        <span class="text-[10px] text-slate-400">{{ filterStatusValues().size }}
                                            selecionado(s)</span>
                                        <div class="flex gap-2">
                                            <button (click)="clearFilter('status')"
                                                class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                            <button (click)="closeFilterPopup()"
                                                class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                        </div>
                                    </div>
                                </div>
                            </th>

                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-100">
                        @if (processedLogs().length === 0) {
                        <tr>
                            <td colspan="9" class="p-8 text-center text-slate-400 text-sm">Nenhum registro encontrado
                                para
                                os filtros informados.</td>
                        </tr>
                        }
                        @for (log of processedLogs(); track log.id) {
                        <tr class="hover:bg-slate-50 transition-colors text-xs text-slate-700">
                            <td class="p-2 font-mono text-slate-600 truncate cursor-pointer hover:text-indigo-600 hover:bg-slate-100 transition-colors"
                                [title]="'Clique para copiar: ' + (log.externalReference || log.id)"
                                (click)="copyToClipboard(log.externalReference || log.id, $event)">
                                <div class="flex items-center gap-1">
                                    <lucide-icon [img]="icons.Copy"
                                        class="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity"></lucide-icon>
                                    <span>{{ log.externalReference || '-' }}</span>
                                </div>
                            </td>
                            <td class="p-2 text-[11.5px] truncate" [title]="log.startDate | date:'dd/MM/yy HH:mm'">{{
                                log.startDate | date:'dd/MM/yy HH:mm' }}</td>
                            <td class="p-2 font-mono text-slate-600 truncate" [title]="log.executionTime">{{
                                formatTimeElapsed(log.executionTime) }}</td>
                            <td class="p-2 text-[11.5px] text-slate-600 truncate" [title]="formatIsoDate(log.startedAt)">{{
                                formatIsoDate(log.startedAt) }}</td>
                            <td class="p-2 text-[11.5px] text-slate-600 truncate" [title]="formatIsoDate(log.finishedAt)">{{
                                formatIsoDate(log.finishedAt) }}</td>

                            <td class="p-2 font-medium text-slate-600 truncate" [title]="log.profileName">{{
                                log.profileName
                                }}</td>
                            <td class="p-2 truncate"><span
                                    class="bg-slate-100 border border-slate-200 px-2 py-1 rounded text-xs font-bold text-slate-700">{{
                                    log.branchCode }}</span></td>
                            <td class="p-2 text-slate-600 truncate" [title]="log.branchName">{{ log.branchName }}</td>
                            <td class="p-2 pr-3 text-center">
                                <div class="flex items-center justify-center gap-1">
                                    @if (log.status === 'Sending') {
                                    <span
                                        class="inline-flex w-[82px] items-center justify-center gap-1 bg-sky-50 text-sky-700 px-1.5 py-1 rounded-md text-[10px] font-bold border border-sky-100 shadow-sm whitespace-nowrap">
                                        <lucide-icon [img]="icons.Loader"
                                            class="w-3 h-3 animate-spin shrink-0"></lucide-icon>
                                        Enviando
                                    </span>
                                    }
                                    @if (log.status === 'Processing') {
                                    <span
                                        class="inline-flex w-[82px] items-center justify-center gap-1 bg-orange-50 text-orange-700 px-1.5 py-1 rounded-md text-[10px] font-bold border border-orange-100 shadow-sm whitespace-nowrap">
                                        <lucide-icon [img]="icons.Loader"
                                            class="w-3 h-3 animate-spin shrink-0"></lucide-icon>
                                        Calculando
                                    </span>
                                    }
                                    @if (log.status === 'Reserved') {
                                    <span
                                        class="inline-flex w-[82px] items-center justify-center gap-1 bg-cyan-50 text-cyan-700 px-1.5 py-1 rounded-md text-[10px] font-bold border border-cyan-100 shadow-sm whitespace-nowrap">
                                        <lucide-icon [img]="icons.Clock" class="w-3 h-3 shrink-0"></lucide-icon>
                                        Reservado
                                    </span>
                                    }
                                    @if (log.status === 'Cancelling') {
                                    <span
                                        class="inline-flex w-[82px] items-center justify-center gap-1 bg-pink-50 text-pink-700 px-1.5 py-1 rounded-md text-[10px] font-bold border border-pink-200 shadow-sm whitespace-nowrap">
                                        <lucide-icon [img]="icons.Loader"
                                            class="w-3 h-3 animate-spin shrink-0"></lucide-icon>
                                        Cancelando
                                    </span>
                                    }
                                    @if (log.status === 'Completed') {
                                    <span
                                        class="inline-flex w-[98px] items-center justify-center gap-1 bg-purple-50 text-purple-700 px-1.5 py-1 rounded-md text-[10px] font-bold border border-purple-100 shadow-sm whitespace-nowrap">
                                        <lucide-icon [img]="icons.Check" class="w-3 h-3 shrink-0"></lucide-icon>
                                        Calc. Finalizado
                                    </span>
                                    }
                                    @if (log.status === 'DocumentsGenerated') {
                                    <span
                                        class="inline-flex w-[98px] items-center justify-center gap-1 bg-green-50 text-green-700 px-1.5 py-1 rounded-md text-[10px] font-bold border border-green-100 shadow-sm whitespace-nowrap">
                                        <lucide-icon [img]="icons.Check" class="w-3 h-3 shrink-0"></lucide-icon>
                                        Doc. Gerados
                                    </span>
                                    }

                                    @if (log.status === 'Pending') {
                                    <span
                                        (click)="authService.hasRole(['Admin', 'Operator']) && confirmCancelExecution(log.id)"
                                        [class.pointer-events-none]="!authService.hasRole(['Admin', 'Operator'])"
                                        class="inline-flex w-[82px] items-center justify-center gap-1 bg-blue-50 text-blue-700 px-1.5 py-1 rounded-md text-[10px] font-bold border border-blue-200 shadow-sm cursor-pointer hover:bg-blue-600 hover:text-white hover:border-blue-600 active:scale-95 transition-all group/wait whitespace-nowrap"
                                        title="Cancelar execução">
                                        <span class="flex items-center gap-1 group-hover/wait:hidden">
                                            <lucide-icon [img]="icons.Clock" class="w-3 h-3 shrink-0"></lucide-icon>
                                            Pendente
                                        </span>
                                        <span *ngIf="authService.hasRole(['Admin', 'Operator'])"
                                            class="hidden group-hover/wait:inline-flex items-center gap-1 text-[10px] font-black">CANCELAR</span>
                                    </span>
                                    }
                                    @if (log.status === 'Error') {
                                    <span
                                        (click)="authService.hasRole(['Admin', 'Operator']) && confirmForceExecution(log.id)"
                                        [class.pointer-events-none]="!authService.hasRole(['Admin', 'Operator'])"
                                        class="inline-flex w-[82px] items-center justify-center gap-1 bg-red-50 text-red-700 px-1.5 py-1 rounded-md text-[10px] font-bold border border-red-200 shadow-sm cursor-pointer hover:bg-red-600 hover:text-white hover:border-red-600 active:scale-95 transition-all group/err whitespace-nowrap"
                                        [title]="log.message">
                                        <span class="flex items-center gap-1 group-hover/err:hidden">
                                            <lucide-icon [img]="icons.AlertCircle"
                                                class="w-3 h-3 shrink-0"></lucide-icon>
                                            Erro
                                        </span>
                                        <span *ngIf="authService.hasRole(['Admin', 'Operator'])"
                                            class="hidden group-hover/err:inline-flex items-center gap-1 text-[10px] font-black">REPROCESSAR</span>
                                    </span>
                                    }
                                    @if (log.status === 'Cancelled') {
                                    <span
                                        class="inline-flex w-[82px] items-center justify-center gap-1 bg-slate-100 text-slate-600 px-1.5 py-1 rounded-md text-[10px] font-bold border border-slate-200 shadow-sm whitespace-nowrap">
                                        <lucide-icon [img]="icons.X" class="w-3 h-3 shrink-0"></lucide-icon>
                                        Cancelado
                                    </span>
                                    }
                                    @if (log.status === 'DocumentFailed') {
                                    <span
                                        (click)="authService.hasRole(['Admin', 'Operator']) && confirmForceExecution(log.id)"
                                        [class.pointer-events-none]="!authService.hasRole(['Admin', 'Operator'])"
                                        class="inline-flex w-[82px] items-center justify-center gap-1 bg-rose-50 text-rose-700 px-1.5 py-1 rounded-md text-[10px] font-bold border border-rose-200 shadow-sm cursor-pointer hover:bg-rose-600 hover:text-white hover:border-rose-600 active:scale-95 transition-all group/err whitespace-nowrap"
                                        [title]="log.message || 'Falha na geração de documentos'">
                                        <span class="flex items-center gap-1 group-hover/err:hidden">
                                            <lucide-icon [img]="icons.AlertCircle"
                                                class="w-3 h-3 shrink-0"></lucide-icon>
                                            Falha Docs.
                                        </span>
                                        <span *ngIf="authService.hasRole(['Admin', 'Operator'])"
                                            class="hidden group-hover/err:inline-flex items-center gap-1 text-[10px] font-black">REPROCESSAR</span>
                                    </span>
                                    }
                                    @if (log.status === 'Deleted') {
                                    <span
                                        class="inline-flex w-[82px] items-center justify-center gap-1 bg-zinc-100 text-zinc-600 px-1.5 py-1 rounded-md text-[10px] font-bold border border-zinc-200 shadow-sm whitespace-nowrap">
                                        <lucide-icon [img]="icons.X" class="w-3 h-3 shrink-0"></lucide-icon>
                                        Excluído
                                    </span>
                                    }

                                    @if (log.status !== 'Processing' && log.status !== 'Sending' && log.status !== 'Completed' && log.status !==
                                    'DocumentsGenerated' && log.status !== 'Pending' && log.status !== 'Error' &&
                                    log.status !== 'Cancelled' && log.status !== 'Reserved' && log.status !==
                                    'Cancelling' &&
                                    log.status !== 'DocumentFailed' && log.status !== 'Deleted') {
                                    <span
                                        class="inline-flex w-[82px] items-center justify-center gap-1 bg-zinc-100 text-zinc-500 px-1.5 py-1 rounded-md text-[10px] font-bold border border-zinc-200 shadow-sm whitespace-nowrap"
                                        [title]="'Status original: ' + log.status">
                                        <lucide-icon [img]="icons.AlertTriangle" class="w-3 h-3 shrink-0"></lucide-icon>
                                        Indefinido
                                    </span>
                                    }

                                    <!-- ACTION: DETALHES -->
                                    <span (click)="openDetailsModal(log.id)"
                                        class="inline-flex w-[72px] items-center justify-center gap-1 bg-indigo-50 text-indigo-700 px-1.5 py-1 rounded-md text-[10px] font-bold border border-indigo-200 shadow-sm cursor-pointer hover:bg-indigo-600 hover:text-white hover:border-indigo-600 active:scale-95 transition-all whitespace-nowrap"
                                        title="Ver Detalhes">
                                        <lucide-icon [img]="icons.FileText" class="w-3 h-3 shrink-0"></lucide-icon>
                                        Detalhes
                                    </span>
                                </div>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div
                class="px-3 py-1.5 bg-slate-50 border-t border-slate-200 text-[10px] text-slate-500 font-medium flex justify-between items-center shrink-0">
                <span>Exibindo <b class="text-slate-700">{{ processedLogs().length }}</b> / <b class="text-slate-700">{{
                        totalItems() }}</b> registros</span>

                <div class="flex items-center gap-3">
                    <!-- Page Size Selector -->
                    <div class="flex items-center gap-1.5">
                        <span class="text-slate-400">Exibir:</span>
                        <select
                            class="text-[11px] font-bold text-slate-700 bg-white border border-slate-200 rounded-md px-2 py-0.5 cursor-pointer focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                            [value]="pageSize()" (change)="mrpService.changePageSize(+$any($event.target).value)">
                            @for (opt of pageSizeOptions; track opt) {
                            <option [value]="opt" [selected]="opt === pageSize()">{{ opt }}</option>
                            }
                        </select>
                    </div>

                    <!-- Divider -->
                    <div class="w-px h-4 bg-slate-200"></div>

                    <!-- Page Navigation -->
                    <div class="flex items-center gap-1">
                        <button (click)="mrpService.prevPage()" [disabled]="currentPage() <= 1"
                            class="px-2 py-0.5 rounded-md border border-slate-200 bg-white text-[10px] font-bold text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 hover:border-indigo-200 transition-colors disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-slate-600 disabled:hover:border-slate-200">
                            ‹ Anterior
                        </button>

                        <span
                            class="px-2 py-0.5 text-[11px] font-bold text-slate-700 bg-white border border-slate-200 rounded-md min-w-[60px] text-center">
                            {{ currentPage() }} / {{ totalPages() }}
                        </span>

                        <button (click)="mrpService.nextPage()" [disabled]="currentPage() >= totalPages()"
                            class="px-2 py-0.5 rounded-md border border-slate-200 bg-white text-[10px] font-bold text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 hover:border-indigo-200 transition-colors disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-slate-600 disabled:hover:border-slate-200">
                            Próxima ›
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- MODAL CONFIRMAÇÃO DE FORÇAR EXECUÇÃO -->
    @if (forceExecutionId()) {
    <div
        class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
        <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 overflow-hidden">
            <div class="flex items-center gap-4 mb-4">
                <div
                    class="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 shrink-0">
                    <lucide-icon [img]="icons.AlertCircle" class="w-6 h-6"></lucide-icon>
                </div>
                <h3 class="text-lg font-bold text-slate-800">Forçar Execução</h3>
            </div>
            <p class="text-sm text-slate-600 mb-8 leading-relaxed">
                Deseja realmente forçar uma nova execução para este ticket? O status será alterado de imediato para
                <span class="font-bold text-blue-600">Calculando</span>.
            </p>
            <div class="flex justify-end gap-3">
                <button (click)="cancelForceExecution()"
                    class="px-4 py-2 text-sm font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors">
                    Cancelar
                </button>
                <button (click)="executeForce()"
                    class="px-4 py-2 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-lg transition-colors shadow-sm flex items-center gap-2">
                    <lucide-icon [img]="icons.Play" class="w-3.5 h-3.5"></lucide-icon> Sim, Forçar
                </button>
            </div>
        </div>
    </div>
    }

    <!-- MODAL ERRO DE AÇÃO -->
    @if (actionErrorMessage()) {
    <div
        class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
        <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 overflow-hidden">
            <div class="flex items-center gap-4 mb-4">
                <div class="w-12 h-12 rounded-full bg-rose-100 flex items-center justify-center text-rose-600 shrink-0">
                    <lucide-icon [img]="icons.AlertCircle" class="w-6 h-6"></lucide-icon>
                </div>
                <h3 class="text-lg font-bold text-slate-800">Erro na Operação</h3>
            </div>
            <p class="text-sm text-slate-600 mb-8 leading-relaxed">
                {{ actionErrorMessage() }}
            </p>
            <div class="flex justify-end">
                <button (click)="actionErrorMessage.set(null)"
                    class="px-4 py-2 text-sm font-medium text-white bg-rose-600 hover:bg-rose-700 rounded-lg transition-colors shadow-sm">
                    Fechar
                </button>
            </div>
        </div>
    </div>
    }
    @if (cancelExecutionId()) {
    <div
        class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
        <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 overflow-hidden">
            <div class="flex items-center gap-4 mb-4">
                <div
                    class="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 shrink-0">
                    <lucide-icon [img]="icons.AlertTriangle" class="w-6 h-6"></lucide-icon>
                </div>
                <h3 class="text-lg font-bold text-slate-800">Cancelar Execução</h3>
            </div>
            <p class="text-sm text-slate-600 mb-8 leading-relaxed">
                Deseja realmente cancelar esta execução? Ela será <span class="font-bold text-red-600">removida da
                    fila</span>.
                Esta ação não se aplica a cálculos que já estão em execução.
            </p>
            <div class="flex justify-end gap-3">
                <button (click)="cancelCancelExecution()"
                    class="px-4 py-2 text-sm font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors">
                    Voltar
                </button>
                <button (click)="executeCancel()"
                    class="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors shadow-sm flex items-center gap-2">
                    <lucide-icon [img]="icons.X" class="w-3.5 h-3.5"></lucide-icon> Sim, Cancelar
                </button>
            </div>
        </div>
    </div>
    }

    <!-- MODAL DE DETALHES DA EXECUÇÃO -->
    @if (isDetailsModalOpen()) {
    <div
        class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
        <div class="bg-white rounded-2xl shadow-2xl w-full flex flex-col overflow-hidden"
            [ngClass]="selectedExecutionDetails()?.status === 'Completed' || selectedExecutionDetails()?.status === 'DocumentsGenerated' ? 'max-w-7xl h-[85vh]' : 'max-w-2xl max-h-[90vh]'">
            <!-- Header -->
            <div class="px-6 py-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/50">
                <div class="flex items-center gap-3">
                    <div class="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600">
                        <lucide-icon [img]="icons.FileText" class="w-5 h-5"></lucide-icon>
                    </div>
                    <div>
                        <h3 class="text-lg font-bold text-slate-800">Detalhes da Execução</h3>
                        <p class="text-xs text-slate-500 font-mono" *ngIf="selectedExecutionDetails() as d">
                            {{ d.externalReference ? 'Ticket: ' + d.externalReference : d.uuid }}
                        </p>
                    </div>
                </div>
                <button (click)="closeDetailsModal()"
                    class="text-slate-400 hover:text-slate-600 hover:bg-slate-100 p-2 rounded-lg transition-colors">
                    <lucide-icon [img]="icons.X" class="w-5 h-5"></lucide-icon>
                </button>
            </div>

            <!-- Content -->
            <div class="flex-1 overflow-y-auto custom-scrollbar relative">

                @if (isLoadingDetails()) {
                <div
                    class="absolute inset-0 flex flex-col items-center justify-center bg-white/80 z-10 backdrop-blur-sm">
                    <lucide-icon [img]="icons.Loader" class="w-8 h-8 text-indigo-600 animate-spin mb-2"></lucide-icon>
                    <span class="text-sm font-medium text-slate-500">Carregando detalhes...</span>
                </div>
                }

                @if (selectedExecutionDetails(); as details) {

                <!-- ===== LAYOUT COMPLETED: 2 colunas ===== -->
                @if (details.status === 'Completed' || details.status === 'DocumentsGenerated') {
                <div class="grid grid-cols-1 lg:grid-cols-5 h-full min-h-0">

                    <!-- COLUNA ESQUERDA (2/5) -->
                    <div
                        class="lg:col-span-2 p-5 border-b lg:border-b-0 lg:border-r border-slate-100 space-y-4 overflow-y-auto custom-scrollbar">
                        <div class="grid grid-cols-2 gap-2">
                            <div class="p-2.5 bg-slate-50 rounded-lg border border-slate-100">
                                <span
                                    class="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">Filial</span>
                                <span class="text-xs font-bold text-slate-700">{{ details.branchCode }}</span>
                                <p class="text-[9px] text-slate-500 truncate">{{ details.branchName }}</p>
                            </div>
                            <div class="p-2.5 bg-slate-50 rounded-lg border border-slate-100">
                                <span
                                    class="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">Perfil</span>
                                <span class="text-xs font-bold text-slate-700">{{ details.calculationProfileName
                                    }}</span>
                            </div>
                            <div class="p-2.5 bg-slate-50 rounded-lg border border-slate-100">
                                <span
                                    class="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">Início</span>
                                <span class="text-xs font-bold text-slate-700">{{ details.startedAt ? (details.startedAt
                                    | date:'dd/MM/yy HH:mm') : '-' }}</span>
                            </div>
                            <div class="p-2.5 bg-slate-50 rounded-lg border border-slate-100">
                                <span
                                    class="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">Fim</span>
                                <span class="text-xs font-bold text-slate-700">{{ details.finishedAt ?
                                    (details.finishedAt | date:'dd/MM/yy HH:mm') : '-' }}</span>
                            </div>
                        </div>
                        <div class="flex gap-2">
                            @if (details.timeElapsed && details.timeElapsed !== '-') {
                            <div
                                class="flex-1 flex items-center gap-1.5 px-3 py-2 bg-indigo-50 rounded-lg border border-indigo-100">
                                <lucide-icon [img]="icons.Clock" class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                <span class="text-[11px] font-bold text-indigo-700">{{
                                    formatTimeElapsed(details.timeElapsed) }}</span>
                            </div>
                            }
                            <div
                                class="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 bg-emerald-50 rounded-lg border border-emerald-100">
                                <lucide-icon [img]="icons.Check" class="w-3.5 h-3.5 text-emerald-600"></lucide-icon>
                                <span class="text-[11px] font-bold text-emerald-700">Concluído</span>
                            </div>
                        </div>
                        @if (details.message) {
                        <div class="flex items-start gap-2 px-3 py-2 bg-amber-50 rounded-lg border border-amber-200">
                            <lucide-icon [img]="icons.AlertTriangle"
                                class="w-3.5 h-3.5 text-amber-600 mt-0.5 shrink-0"></lucide-icon>
                            <p class="text-[11px] text-amber-700">{{ details.message }}</p>
                        </div>
                        }
                        @if (details.protheusMemoryLoadStatus || details.protheusLevelRecalculationStatus ||
                        details.protheusCalculationStatus || details.protheusPersistenceStatus) {
                        <div>
                            <h4 class="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">Pipeline
                                Protheus</h4>
                            <div class="space-y-2">
                                <div class="flex items-center justify-between px-2 py-1.5 rounded-md"
                                    [ngClass]="details.protheusMemoryLoadStatus === 'Loaded' || details.protheusMemoryLoadStatus === 'Unloaded' ? 'bg-emerald-50' : 'bg-slate-50'">
                                    <span class="text-[11px] text-slate-600">Carga em Memória</span>
                                    <span class="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                                        [ngClass]="details.protheusMemoryLoadStatus === 'Loaded' || details.protheusMemoryLoadStatus === 'Unloaded' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-200 text-slate-500'">
                                        {{ details.protheusMemoryLoadStatus || 'Pendente' }}
                                    </span>
                                </div>
                                <div class="flex items-center justify-between px-2 py-1.5 rounded-md"
                                    [ngClass]="details.protheusLevelRecalculationStatus === 'Completed' ? 'bg-emerald-50' : 'bg-slate-50'">
                                    <span class="text-[11px] text-slate-600">Recálculo Níveis</span>
                                    <span class="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                                        [ngClass]="details.protheusLevelRecalculationStatus === 'Completed' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-200 text-slate-500'">
                                        {{ details.protheusLevelRecalculationStatus || 'Pendente' }}
                                    </span>
                                </div>
                                <div class="flex items-center justify-between px-2 py-1.5 rounded-md"
                                    [ngClass]="details.protheusCalculationStatus === 'Completed' ? 'bg-emerald-50' : 'bg-slate-50'">
                                    <span class="text-[11px] text-slate-600">Cálculo MRP</span>
                                    <span class="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                                        [ngClass]="details.protheusCalculationStatus === 'Completed' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-200 text-slate-500'">
                                        {{ details.protheusCalculationStatus || 'Pendente' }}
                                    </span>
                                </div>
                                <div class="flex items-center justify-between px-2 py-1.5 rounded-md"
                                    [ngClass]="details.protheusPersistenceStatus === 'Completed' ? 'bg-emerald-50' : 'bg-slate-50'">
                                    <span class="text-[11px] text-slate-600">Persistência</span>
                                    <span class="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                                        [ngClass]="details.protheusPersistenceStatus === 'Completed' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-200 text-slate-500'">
                                        {{ details.protheusPersistenceStatus || 'Pendente' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        }
                    </div>

                    <!-- COLUNA DIREITA (3/5) -->
                    <div class="lg:col-span-3 flex flex-col min-h-0">
                        <div class="flex border-b border-slate-200 shrink-0">
                            <button (click)="expandedTab.set('accuracy')"
                                class="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-[11px] font-bold uppercase tracking-wider transition-colors"
                                [ngClass]="expandedTab() === 'accuracy' ? 'text-indigo-700 border-b-2 border-indigo-600 bg-white' : 'text-slate-500 hover:text-slate-700 bg-slate-50 hover:bg-slate-100'">
                                <lucide-icon [img]="icons.BarChart3" class="w-3.5 h-3.5"></lucide-icon>
                                Acuracidade
                            </button>
                            @if (details.status === 'DocumentsGenerated') {
                            <button (click)="expandedTab.set('purchase')"
                                class="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-[11px] font-bold uppercase tracking-wider transition-colors"
                                [ngClass]="expandedTab() === 'purchase' ? 'text-indigo-700 border-b-2 border-indigo-600 bg-white' : 'text-slate-500 hover:text-slate-700 bg-slate-50 hover:bg-slate-100'">
                                <lucide-icon [img]="icons.ShoppingCart" class="w-3.5 h-3.5"></lucide-icon>
                                Solicitações de Compra
                            </button>
                            }
                        </div>
                        <div class="flex-1 p-4 overflow-y-auto custom-scrollbar">
                            @if (isLoadingExpanded()) {
                            <div class="flex flex-col items-center justify-center py-12">
                                <lucide-icon [img]="icons.Loader"
                                    class="w-7 h-7 text-indigo-600 animate-spin mb-2"></lucide-icon>
                                <span class="text-xs font-medium text-slate-500">Carregando dados...</span>
                            </div>
                            } @else {
                            @if (expandedTab() === 'accuracy') {
                            <div class="space-y-4 animate-fade-in">
                                @if (productsSummary(); as summary) {
                                <div class="grid grid-cols-3 gap-3">
                                    <div
                                        class="p-3 rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-600 text-white text-center shadow-md">
                                        <span
                                            class="block text-[9px] font-bold uppercase tracking-wider opacity-80 mb-0.5">Acuracidade</span>
                                        <span class="text-2xl font-black">{{ getAccuracyPercentage() }}%</span>
                                    </div>
                                    <div class="p-3 rounded-xl bg-emerald-50 border border-emerald-100 text-center">
                                        <span
                                            class="block text-[9px] font-bold text-emerald-600 uppercase tracking-wider mb-0.5">Compatíveis</span>
                                        <span class="text-xl font-black text-emerald-700">{{ summary.matchedCount
                                            }}</span>
                                    </div>
                                    <div class="p-3 rounded-xl bg-red-50 border border-red-100 text-center">
                                        <span
                                            class="block text-[9px] font-bold text-red-600 uppercase tracking-wider mb-0.5">Divergências</span>
                                        <span class="text-xl font-black text-red-700">{{ summary.physicalExcessCount +
                                            summary.physicalDeficitCount }}</span>
                                        <div class="flex justify-center gap-2 mt-0.5">
                                            <span class="text-[9px] text-red-500">Exc: {{ summary.physicalExcessCount
                                                }}</span>
                                            <span class="text-[9px] text-red-500">Déf: {{ summary.physicalDeficitCount
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                                @if (summary.divergences && summary.divergences.length > 0) {
                                <div>
                                    <h4 class="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">
                                        Produtos com Divergência</h4>
                                    <div class="rounded-lg border border-slate-200 overflow-x-auto">
                                        <table class="w-full text-[11px]">
                                            <thead>
                                                <tr class="bg-slate-50 text-left">
                                                    <th class="p-2 font-bold text-slate-600 uppercase tracking-wider">
                                                        Código</th>
                                                    <th class="p-2 font-bold text-slate-600 uppercase tracking-wider">
                                                        Produto</th>
                                                    <th
                                                        class="p-2 font-bold text-slate-600 uppercase tracking-wider text-right">
                                                        Saldo Fís.</th>
                                                    <th
                                                        class="p-2 font-bold text-slate-600 uppercase tracking-wider text-right">
                                                        Saldo MRP</th>
                                                    <th
                                                        class="p-2 font-bold text-slate-600 uppercase tracking-wider text-right">
                                                        Dif.</th>
                                                </tr>
                                            </thead>
                                            <tbody class="divide-y divide-slate-100">
                                                @for (div of summary.divergences; track div.productCode) {
                                                <tr class="hover:bg-slate-50 transition-colors">
                                                    <td class="p-2 font-mono text-slate-600">{{ div.productCode }}</td>
                                                    <td class="p-2 text-slate-700 truncate max-w-[180px]"
                                                        [title]="div.productName">{{ div.productName }}</td>
                                                    <td class="p-2 text-right font-mono text-slate-600">{{
                                                        div.physicalBalance | number:'1.2-2' }}</td>
                                                    <td class="p-2 text-right font-mono text-slate-600">{{
                                                        div.mrpBalance | number:'1.2-2' }}</td>
                                                    <td class="p-2 text-right font-mono font-bold"
                                                        [ngClass]="div.difference > 0 ? 'text-emerald-600' : div.difference < 0 ? 'text-red-600' : 'text-slate-400'">
                                                        {{ div.difference | number:'1.2-2' }}
                                                    </td>
                                                </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                } @else {
                                <div class="text-center py-6 text-slate-400 text-xs">Nenhuma divergência encontrada.
                                </div>
                                }
                                } @else {
                                <div class="text-center py-8 text-slate-400 text-xs">Dados de acuracidade não
                                    disponíveis.</div>
                                }
                            </div>
                            }
                            @if (expandedTab() === 'purchase') {
                            <div class="space-y-3 animate-fade-in">
                                @if (purchaseRequests(); as requests) {
                                @if (requests.length > 0) {
                                @for (req of requests; track req.purchaseRequestNumber) {
                                <div class="rounded-lg border border-slate-200 overflow-hidden">
                                    <div
                                        class="px-3 py-2 bg-slate-50 border-b border-slate-200 flex items-center justify-between">
                                        <div class="flex items-center gap-1.5">
                                            <lucide-icon [img]="icons.FileText"
                                                class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                            <span class="text-xs font-bold text-slate-700">SC {{
                                                req.purchaseRequestNumber }}</span>
                                        </div>
                                        <span class="text-[10px] text-slate-400 font-medium">{{ req.items.length }}
                                            itens</span>
                                    </div>
                                    <div class="overflow-x-auto">
                                        <table class="w-full text-[11px]">
                                            <thead>
                                                <tr class="bg-slate-50/50 text-left">
                                                    <th class="p-2 font-bold text-slate-600 uppercase tracking-wider">
                                                        Código</th>
                                                    <th class="p-2 font-bold text-slate-600 uppercase tracking-wider">
                                                        Produto</th>
                                                    <th
                                                        class="p-2 font-bold text-slate-600 uppercase tracking-wider text-center">
                                                        UN</th>
                                                    <th
                                                        class="p-2 font-bold text-slate-600 uppercase tracking-wider text-right">
                                                        Qtd</th>
                                                </tr>
                                            </thead>
                                            <tbody class="divide-y divide-slate-100">
                                                @for (item of req.items; track item.productCode) {
                                                <tr class="hover:bg-slate-50 transition-colors">
                                                    <td class="p-2 font-mono text-slate-600">{{ item.productCode }}</td>
                                                    <td class="p-2 text-slate-700 truncate max-w-[200px]"
                                                        [title]="item.productName">{{ item.productName }}</td>
                                                    <td class="p-2 text-center text-slate-500 font-medium">{{
                                                        item.unitOfMeasure }}</td>
                                                    <td class="p-2 text-right font-mono font-bold text-slate-700">{{
                                                        item.quantity | number:'1.3-3' }}</td>
                                                </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                }
                                } @else {
                                <div class="text-center py-8 text-slate-400 text-xs">Nenhuma solicitação de compra
                                    gerada.</div>
                                }
                                } @else {
                                <div class="text-center py-8 text-slate-400 text-xs">Dados de solicitações não
                                    disponíveis.</div>
                                }
                            </div>
                            }
                            }
                        </div>
                    </div>
                </div>
                }

                <!-- ===== LAYOUT OUTROS STATUS ===== -->
                @if (details.status !== 'Completed' && details.status !== 'DocumentsGenerated') {
                <div class="p-5 space-y-4">
                    <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
                        <div class="p-2.5 bg-slate-50 rounded-lg border border-slate-100">
                            <span
                                class="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">Filial</span>
                            <span class="text-xs font-bold text-slate-700">{{ details.branchCode }}</span>
                            <p class="text-[9px] text-slate-500 truncate">{{ details.branchName }}</p>
                        </div>
                        <div class="p-2.5 bg-slate-50 rounded-lg border border-slate-100">
                            <span
                                class="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">Perfil</span>
                            <span class="text-xs font-bold text-slate-700">{{ details.calculationProfileName }}</span>
                        </div>
                        <div class="p-2.5 bg-slate-50 rounded-lg border border-slate-100">
                            <span
                                class="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">Início</span>
                            <span class="text-xs font-bold text-slate-700">{{ details.startedAt ? (details.startedAt |
                                date:'dd/MM/yy HH:mm') : '-' }}</span>
                        </div>
                        <div class="p-2.5 bg-slate-50 rounded-lg border border-slate-100">
                            <span
                                class="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">Fim</span>
                            <span class="text-xs font-bold text-slate-700">{{ details.finishedAt ? (details.finishedAt |
                                date:'dd/MM/yy HH:mm') : '-' }}</span>
                        </div>
                    </div>
                    @if (details.timeElapsed && details.timeElapsed !== '-') {
                    <div class="flex items-center gap-2 px-3 py-2 bg-indigo-50 rounded-lg border border-indigo-100">
                        <lucide-icon [img]="icons.Clock" class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                        <span class="text-[11px] font-bold text-indigo-700">Tempo de execução: {{
                            formatTimeElapsed(details.timeElapsed) }}</span>
                    </div>
                    }
                    @if (details.status === 'Pending') {
                    <div class="bg-amber-50 border border-amber-200 rounded-lg p-3 flex items-start gap-2">
                        <lucide-icon [img]="icons.Clock" class="w-4 h-4 text-amber-600 mt-0.5 shrink-0"></lucide-icon>
                        <div>
                            <h4 class="text-xs font-bold text-amber-800">Aguardando Execução</h4>
                            <p class="text-[11px] text-amber-700 mt-0.5">A execução está na fila aguardando
                                processamento.</p>
                        </div>
                    </div>
                    }
                    @if (details.status === 'Processing') {
                    <div class="bg-blue-50 border border-blue-200 rounded-lg p-3 flex items-start gap-2">
                        <lucide-icon [img]="icons.Loader"
                            class="w-4 h-4 text-blue-600 mt-0.5 shrink-0 animate-spin"></lucide-icon>
                        <div>
                            <h4 class="text-xs font-bold text-blue-800">Em Processamento</h4>
                            <p class="text-[11px] text-blue-700 mt-0.5">A execução está sendo processada no momento.</p>
                        </div>
                    </div>
                    }
                    @if (details.status === 'Error') {
                    <div class="bg-red-50 border border-red-200 rounded-lg p-3 flex items-start gap-2">
                        <lucide-icon [img]="icons.AlertCircle"
                            class="w-4 h-4 text-red-600 mt-0.5 shrink-0"></lucide-icon>
                        <div>
                            <h4 class="text-xs font-bold text-red-800">Erro na Execução</h4>
                            <p class="text-[11px] text-red-700 mt-0.5">Ocorreu um erro durante o processamento desta
                                execução.</p>
                        </div>
                    </div>
                    }
                    @if (details.status === 'Cancelled') {
                    <div class="bg-amber-50 border border-amber-200 rounded-lg p-3 flex items-start gap-2">
                        <lucide-icon [img]="icons.AlertTriangle"
                            class="w-4 h-4 text-amber-600 mt-0.5 shrink-0"></lucide-icon>
                        <div>
                            <h4 class="text-xs font-bold text-amber-800">Cálculo Cancelado</h4>
                            <p class="text-[11px] text-amber-700 mt-0.5">Cálculo cancelado, envie uma nova execução para a filial.</p>
                        </div>
                    </div>
                    }
                    @if (details.message) {
                    <div class="flex items-start gap-2 px-3 py-2 bg-amber-50 rounded-lg border border-amber-200">
                        <lucide-icon [img]="icons.AlertTriangle"
                            class="w-3.5 h-3.5 text-amber-600 mt-0.5 shrink-0"></lucide-icon>
                        <div>
                            <h4 class="text-[10px] font-bold text-amber-800 uppercase tracking-wider mb-0.5">Mensagem
                            </h4>
                            <p class="text-[11px] text-amber-700">{{ details.message }}</p>
                        </div>
                    </div>
                    }
                    @if (details.protheusMemoryLoadStatus || details.protheusLevelRecalculationStatus ||
                    details.protheusCalculationStatus || details.protheusPersistenceStatus) {
                    <div>
                        <h4
                            class="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-3 border-b border-slate-100 pb-1">
                            Pipeline Protheus</h4>
                        <div class="relative pl-4 border-l-2 border-slate-100 space-y-5 ml-2">
                            <div class="relative">
                                <span
                                    class="absolute -left-[21px] top-0 w-4 h-4 rounded-full border-2 flex items-center justify-center bg-white"
                                    [ngClass]="details.protheusMemoryLoadStatus === 'Loaded' || details.protheusMemoryLoadStatus === 'Unloaded' ? 'border-emerald-500' : 'border-slate-300'">
                                    <div class="w-1.5 h-1.5 rounded-full"
                                        [ngClass]="details.protheusMemoryLoadStatus === 'Loaded' || details.protheusMemoryLoadStatus === 'Unloaded' ? 'bg-emerald-500' : 'bg-slate-300'">
                                    </div>
                                </span>
                                <div class="flex items-center justify-between">
                                    <span class="text-xs text-slate-700">Carga em Memória</span>
                                    <span class="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                                        [ngClass]="details.protheusMemoryLoadStatus === 'Loaded' || details.protheusMemoryLoadStatus === 'Unloaded' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'">
                                        {{ details.protheusMemoryLoadStatus || 'Pendente' }}
                                    </span>
                                </div>
                            </div>
                            <div class="relative">
                                <span
                                    class="absolute -left-[21px] top-0 w-4 h-4 rounded-full border-2 flex items-center justify-center bg-white"
                                    [ngClass]="details.protheusLevelRecalculationStatus === 'Completed' ? 'border-emerald-500' : 'border-slate-300'">
                                    <div class="w-1.5 h-1.5 rounded-full"
                                        [ngClass]="details.protheusLevelRecalculationStatus === 'Completed' ? 'bg-emerald-500' : 'bg-slate-300'">
                                    </div>
                                </span>
                                <div class="flex items-center justify-between">
                                    <span class="text-xs text-slate-700">Recálculo de Níveis</span>
                                    <span class="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                                        [ngClass]="details.protheusLevelRecalculationStatus === 'Completed' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'">
                                        {{ details.protheusLevelRecalculationStatus || 'Pendente' }}
                                    </span>
                                </div>
                            </div>
                            <div class="relative">
                                <span
                                    class="absolute -left-[21px] top-0 w-4 h-4 rounded-full border-2 flex items-center justify-center bg-white"
                                    [ngClass]="details.protheusCalculationStatus === 'Completed' ? 'border-emerald-500' : 'border-slate-300'">
                                    <div class="w-1.5 h-1.5 rounded-full"
                                        [ngClass]="details.protheusCalculationStatus === 'Completed' ? 'bg-emerald-500' : 'bg-slate-300'">
                                    </div>
                                </span>
                                <div class="flex items-center justify-between">
                                    <span class="text-xs text-slate-700">Cálculo MRP</span>
                                    <span class="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                                        [ngClass]="details.protheusCalculationStatus === 'Completed' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'">
                                        {{ details.protheusCalculationStatus || 'Pendente' }}
                                    </span>
                                </div>
                            </div>
                            <div class="relative">
                                <span
                                    class="absolute -left-[21px] top-0 w-4 h-4 rounded-full border-2 flex items-center justify-center bg-white"
                                    [ngClass]="details.protheusPersistenceStatus === 'Completed' ? 'border-emerald-500' : 'border-slate-300'">
                                    <div class="w-1.5 h-1.5 rounded-full"
                                        [ngClass]="details.protheusPersistenceStatus === 'Completed' ? 'bg-emerald-500' : 'bg-slate-300'">
                                    </div>
                                </span>
                                <div class="flex items-center justify-between">
                                    <span class="text-xs text-slate-700">Persistência de Dados</span>
                                    <span class="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                                        [ngClass]="details.protheusPersistenceStatus === 'Completed' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'">
                                        {{ details.protheusPersistenceStatus || 'Pendente' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                }

                }
            </div>

            <!-- Footer -->
            <div class="px-5 py-3 bg-slate-50 border-t border-slate-200 flex justify-end shrink-0">
                <button (click)="closeDetailsModal()"
                    class="px-4 py-2 text-sm font-medium text-slate-600 bg-white border border-slate-200 hover:bg-slate-50 rounded-lg transition-colors shadow-sm">
                    Fechar
                </button>
            </div>
        </div>
    </div>
    }

    <!-- MODAL NOVA EXECUÇÃO -->
    @if (isNewExecutionModalOpen()) {
    <div
        class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
        <div class="bg-white rounded-2xl shadow-2xl w-full max-w-5xl p-6 overflow-hidden flex flex-col h-[85vh]">
            <div class="flex justify-between items-center mb-4 shrink-0">
                <div>
                    <h3 class="text-xl font-bold text-slate-800 flex items-center gap-2">
                        <lucide-icon [img]="icons.Plus" class="w-5 h-5 text-indigo-600"></lucide-icon> Nova Execução
                    </h3>
                    <p class="text-xs text-slate-500 mt-1">Selecione perfis e filiais para iniciar o cálculo.</p>
                </div>
                <button (click)="closeNewExecutionModal()"
                    class="text-slate-400 hover:text-slate-600 transition-colors">
                    <lucide-icon [img]="icons.X" class="w-6 h-6"></lucide-icon>
                </button>
            </div>

            <div class="flex-1 min-h-0 grid grid-cols-1 md:grid-cols-2 gap-6">

                <!-- ESQUERDA: LISTA DE PERFIS -->
                <div class="flex flex-col h-full bg-slate-50/50 rounded-xl border border-slate-200 overflow-hidden">
                    <!-- Header / Search -->
                    <div class="p-3 border-b border-slate-200 bg-white">
                        <label class="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Perfis ({{
                            selectedProfileIds().length }})</label>
                        <div class="flex items-center gap-2">
                            <select
                                class="text-[11px] font-bold text-slate-700 bg-slate-50 border border-slate-200 rounded-lg px-2 py-2 cursor-pointer focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none transition-all shrink-0"
                                [value]="profileSearchAspect()"
                                (change)="profileSearchAspect.set($any($event.target).value)">
                                @for (opt of profileAspectOptions; track opt.value) {
                                    <option [value]="opt.value">{{ opt.label }}</option>
                                }
                            </select>
                            <div class="relative flex-1">
                                <lucide-icon [img]="icons.Filter"
                                    class="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"></lucide-icon>
                                <input type="text" [formControl]="profileSearchCtrl"
                                    [placeholder]="profileSearchAspect() === 'code' ? 'Buscar por código...' : profileSearchAspect() === 'name' ? 'Buscar por nome...' : 'Buscar perfil...'"
                                    class="w-full text-xs pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none transition-all">
                            </div>
                        </div>
                    </div>

                    <!-- Lista -->
                    <div class="flex-1 overflow-y-auto p-2 space-y-1">
                        @for (profile of filteredProfiles(); track profile.id) {
                        <label
                            class="flex items-start p-3 rounded-lg border border-transparent hover:bg-white hover:border-slate-100 hover:shadow-sm cursor-pointer transition-all group"
                            [class.bg-indigo-50]="selectedProfileIds().includes(profile.id)"
                            [class.border-indigo-100]="selectedProfileIds().includes(profile.id)">
                            <div class="pt-0.5 mr-3">
                                <input type="checkbox" [value]="profile.id"
                                    (change)="toggleSelection('profiles', profile.id)"
                                    [checked]="selectedProfileIds().includes(profile.id)" class="checkbox-indigo">
                            </div>
                            <div class="flex-1 min-w-0">
                                <div class="flex justify-between items-center mb-0.5">
                                    <span class="text-xs font-bold font-mono text-slate-700"
                                        [class.text-indigo-700]="selectedProfileIds().includes(profile.id)">{{
                                        profile.TELA_1.HW2_CODIGO }}</span>
                                </div>
                                <p class="text-xs text-slate-500 truncate"
                                    [class.text-indigo-600]="selectedProfileIds().includes(profile.id)">{{ profile.name
                                    }}
                                </p>
                                @if (profile.lastDemandImportAt) {
                                <p class="text-[10px] text-slate-400 mt-0.5 flex items-center gap-1"
                                    [class.text-indigo-400]="selectedProfileIds().includes(profile.id)">
                                    <lucide-icon [img]="icons.Calendar" class="w-2.5 h-2.5 shrink-0"></lucide-icon>
                                    Dem. importada: {{ profile.lastDemandImportAt | date:'dd/MM/yy HH:mm' }}
                                </p>
                                }
                            </div>
                        </label>
                        }
                    </div>
                </div>

                <!-- DIREITA: LISTA DE FILIAIS -->
                <div class="flex flex-col h-full bg-slate-50/50 rounded-xl border border-slate-200 overflow-hidden">
                    <!-- Header / Search + Actions -->
                    <div class="p-3 border-b border-slate-200 bg-white">
                        <div class="flex justify-between items-center mb-2">
                            <label class="block text-xs font-bold text-slate-500 uppercase tracking-wider">Filiais ({{
                                selectedBranchIds().length }})</label>
                            <div class="flex gap-1">
                                <button (click)="selectAllModalBranches()"
                                    class="text-[10px] font-bold text-indigo-600 hover:bg-indigo-50 px-2 py-1 rounded transition-colors">Todos</button>
                                <button (click)="deselectAllModalBranches()"
                                    class="text-[10px] font-bold text-slate-500 hover:bg-slate-100 px-2 py-1 rounded transition-colors">Nada</button>
                            </div>
                        </div>

                        <div class="flex items-center gap-2">
                            <select
                                class="text-[11px] font-bold text-slate-700 bg-slate-50 border border-slate-200 rounded-lg px-2 py-2 cursor-pointer focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none transition-all shrink-0"
                                [value]="branchSearchAspect()"
                                (change)="branchSearchAspect.set($any($event.target).value)">
                                @for (opt of branchAspectOptions; track opt.value) {
                                    <option [value]="opt.value">{{ opt.label }}</option>
                                }
                            </select>
                            <div class="relative flex-1">
                                <lucide-icon [img]="icons.Filter"
                                    class="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"></lucide-icon>
                                <input type="text" [formControl]="branchSearchCtrl"
                                    [placeholder]="branchSearchAspect() === 'code' ? 'Buscar por código...' : branchSearchAspect() === 'name' ? 'Buscar por nome...' : branchSearchAspect() === 'state' ? 'Buscar por UF...' : 'Buscar filial (nome, cód, uf)...'"
                                    class="w-full text-xs pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none transition-all">
                            </div>
                        </div>
                    </div>

                    <!-- Lista -->
                    <div class="flex-1 overflow-y-auto p-2 space-y-1">
                        @for (branch of filteredBranches(); track branch.id) {
                        <label class="flex items-start p-3 rounded-lg border border-transparent transition-all group"
                            [class.hover:bg-white]="branch.calculateMrp"
                            [class.hover:border-slate-100]="branch.calculateMrp"
                            [class.hover:shadow-sm]="branch.calculateMrp" [class.cursor-pointer]="branch.calculateMrp"
                            [class.cursor-not-allowed]="!branch.calculateMrp" [class.opacity-50]="!branch.calculateMrp"
                            [class.bg-indigo-50]="isBranchSelectedForExecution(branch.id) && branch.calculateMrp"
                            [class.border-indigo-100]="isBranchSelectedForExecution(branch.id) && branch.calculateMrp">

                            <div class="pt-0.5 mr-3">
                                <input type="checkbox" [value]="branch.id"
                                    (change)="toggleSelection('branches', branch.id)"
                                    [checked]="isBranchSelectedForExecution(branch.id)"
                                    [disabled]="!branch.calculateMrp" class="checkbox-indigo">
                            </div>

                            <div class="flex-1 min-w-0">
                                <div class="flex items-center gap-2 mb-0.5">
                                    <span class="text-[10px] font-bold px-1.5 py-0.5 rounded"
                                        [class.bg-slate-200]="!isBranchSelectedForExecution(branch.id)"
                                        [class.text-slate-600]="!isBranchSelectedForExecution(branch.id)"
                                        [class.bg-indigo-200]="isBranchSelectedForExecution(branch.id) && branch.calculateMrp"
                                        [class.text-indigo-700]="isBranchSelectedForExecution(branch.id) && branch.calculateMrp">
                                        {{ branch.state }}
                                    </span>
                                    <span class="text-xs font-bold text-slate-700"
                                        [class.text-indigo-700]="isBranchSelectedForExecution(branch.id) && branch.calculateMrp">
                                        {{ branch.code }}
                                    </span>
                                    <span *ngIf="!branch.calculateMrp"
                                        class="text-[9px] font-bold text-red-400 bg-red-50 px-1.5 py-0.5 rounded uppercase tracking-wider">Indisponível</span>
                                </div>
                                <p class="text-xs text-slate-500 truncate"
                                    [class.text-indigo-600]="isBranchSelectedForExecution(branch.id) && branch.calculateMrp">
                                    {{ branch.name }}
                                </p>
                            </div>
                        </label>
                        }
                    </div>
                </div>
            </div>

            <!-- FOOTER: TOTALIZADORES E AÇÃO -->
            <div
                class="mt-4 pt-4 border-t border-slate-100 flex flex-col sm:flex-row justify-between items-center gap-4 shrink-0">

                <!-- Resumo da Operação -->
                <div class="flex items-center gap-6 text-sm">
                    <div class="hidden sm:block">
                        <span class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider">Resumo</span>
                        <div class="flex items-baseline gap-1 text-slate-600">
                            <span class="font-bold text-indigo-600">{{ selectedProfileIds().length }}</span> perfis
                            <span class="text-slate-300 mx-1">×</span>
                            <span class="font-bold text-indigo-600">{{ selectedBranchIds().length }}</span> filiais
                        </div>
                    </div>

                    <div class="bg-indigo-50 px-4 py-2 rounded-xl border border-indigo-100 flex items-center gap-3">
                        <div
                            class="w-8 h-8 rounded-full bg-indigo-100/50 flex items-center justify-center text-indigo-600">
                            <lucide-icon [img]="icons.Layers" class="w-4 h-4"></lucide-icon>
                        </div>
                        <div>
                            <span
                                class="block text-[10px] font-bold text-indigo-400 uppercase tracking-wider leading-none mb-0.5">Total
                                de Execuções</span>
                            <span class="text-lg font-black text-indigo-700 leading-none">{{ totalExecutionsCount()
                                }}</span>
                        </div>
                    </div>
                </div>

                <div class="flex gap-3 w-full sm:w-auto">
                    <button (click)="closeNewExecutionModal()"
                        class="flex-1 sm:flex-none px-4 py-2.5 text-sm font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors">
                        Cancelar
                    </button>
                    <button (click)="executeNewBatch()" [disabled]="totalExecutionsCount() === 0"
                        class="flex-1 sm:flex-none px-6 py-2.5 text-sm font-bold text-white bg-indigo-600 hover:bg-indigo-700 rounded-xl transition-colors shadow-lg shadow-indigo-200 disabled:opacity-50 disabled:shadow-none flex items-center justify-center gap-2">
                        <lucide-icon [img]="icons.Play" class="w-4 h-4"></lucide-icon>
                        <span>Confirmar Execução</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    }
</div>